import { createFileRoute } from "@tanstack/react-router";

import TablesPage from "@/admin/settings/tables/page";

export const Route = createFileRoute("/app/$storeId/settings/tables")({
    component: RouteComponent,
});

function RouteComponent() {
    return <TablesPage />;
}
